import { render, staticRenderFns } from "./CourierService.vue?vue&type=template&id=998ea788&scoped=true"
import script from "./CourierService.vue?vue&type=script&lang=js"
export * from "./CourierService.vue?vue&type=script&lang=js"
import style0 from "./CourierService.vue?vue&type=style&index=0&id=998ea788&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998ea788",
  null
  
)

export default component.exports